import React from "react";
import SecTitle from "../Common/SecTitle";
import Card from "./Card";
const Cards = () => {
  var cards = [
    {
      id: 1,
      picUrl: "",
      text: "طراحی و پیاده سازی سفارشی نرم افزار مناسب برای پلتفرم موبایل، این طراحی ممکن است با هریک از تکنولوژی های موجود بسته به محدودیت های ابزار و نیازمندی های نرم افزار ممکن است انتخاب شود.	",
      icon_name: "fa-android",
    },
    {
      id: 2,
      picUrl: "",
      text: "خدمات مشاوره حوزه کسب و کار : برگزاری جلسات مشاوره با متقاضیان در حوزه چالش های کسب و کار فناورانه خود، از مرحله شکل گیری ایده تا استقرار و نگهداری و تثبیت در بازار",
      icon_name: "fa-laptop",
    },
    {
      id: 3,
      picUrl: "",
      text: "طراحی و پیاده سازی سفارشی نرم افزار مناسب برای پلتفرم های وب و سیستم عامل ها، و این طراحی با توجه به نیازمندی های فعلی و آتی کسب و کار و یا نرم افزارطراحی میگردد",
      icon_name: "fa-wordpress",
    },
    {
      id: 4,
      picUrl: "",
      text: "راهکار های کسب و کار ویونا شامل مجموعه از محصولات است که توسط ویونا از قبل طراحی شده است و با درخواست کارفرما، برای کسب و کار ایشان، شخصی سازی می شوند",
      icon_name: "fa-mobile",
    },
  ];
  return (
    <section className="blur_bg py-5">
      <div className="container">
        <SecTitle title="خدمات قابل ارائه" />

        <div className="row cards_wrapper mt-5 mx-3 ">
          {cards.map((card) => (
            <div key={card.id} className="col-lg-3 col-md-6 mb-3">
              <Card card={card} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Cards;
